'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import Cart from "./components/cart";
import Guest from "./components/guest";
import Checkout from './components/Checkout.vue';
import UserHandler from "./components/user-handler";
import PaymentType from "./components/payment-type";
import ShippingType from "./components/shipping-type";
import ShippingAddress from "./components/shipping-address";
import CheckoutProgress from "./components/checkout-progress";
import ExtraFields from "./components/extra-fields";

var _class = function _class() {
  _classCallCheck(this, _class);

  // Register components

  this.cart = new Cart();
  this.guest = new Guest();
  this.paymentType = new PaymentType();
  this.shippingType = new ShippingType();
  this.shippingAddress = new ShippingAddress();
  this.shippingAddress = new ShippingAddress();
  this.userHandler = new UserHandler();
  this.ExtraFields = new ExtraFields();

  new CheckoutProgress();

  Vue.component('checkout', Checkout);
};

export default _class;


//////////////////
// WEBPACK FOOTER
// ./resources/templates/semperit/assets/js/modules/checkout/index.js
// module id = null
// module chunks = 